import { each, uniq } from 'lodash';
import { lodashContains } from '../../util/lodash_migration';

// get a list of user roles for a given team and cohort
export function getRoles(user: User, team: any, cohort: any): string[] {
    // Check for missing user or roles
    if (user === undefined) return [];
    if (user.roles === undefined) return [];

    let buffer = [];

    const keys = Object.keys(user.roles);

    for (let i = 0; i < keys.length; i++) {
        const key = keys[i];

        if (team && team.id === key || cohort && cohort.id === key) {
            let subBuffer = '';

            const subKeys = Object.keys(user.roles[key]);

            for (let c = 0; c < subKeys.length; c++) {
                subBuffer += user.roles[key][subKeys[c]];
            }

            buffer.push(subBuffer);
        }
    }

    return uniq(buffer);
}

// Return a list of all the role names a user has in an entire organization
export function getAllRoles(user: User, org: any): string[] {
    let roles: string[] = [];

    // Insure the org state is present
    if (!org) {
        return roles;
    }

    if (!user) {
        return roles;
    }

    if (!org.roles) {
        return roles;
    }

    // Ensure that this user has roles in the organization
    if (!org.roles[user.id]) {
        return roles;
    }

    each(org.roles[user.id], (role) => {
        roles.push(role.type);
    });

    return uniq(roles);
}

// determine by userRoles (returned by getRoles above) if
// the user is an instructor (note they can also be something else)
export function isInstructor(userRoles: string[]): boolean {
    return lodashContains(userRoles, 'Instructor');
}

// determine by userRoles if
// the user has a system administrator role
export function isSystemAdmin(userRoles: string[]): boolean {
    return lodashContains(userRoles, 'SystemAdministrator');
}

// determine by userRoles if
// the user has any administrator role
export function isAdmin(userRoles: string[]): boolean {
    return (
        lodashContains(userRoles, 'SystemAdministrator') ||
        lodashContains(userRoles, 'Administrator') ||
        lodashContains(userRoles, 'CohortAdministrator')
    );

}
